import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { post } from "common/helpers/HTTP";

async function getSourceResultsTotal(
  workspaceId: string,
  listId: string,
  sourceId: string,
): Promise<number> {
  const { total } = await post(
    `workspaces/${workspaceId}/lists/${listId}/source/${sourceId}/results-search-total`,
    {},
  );
  return total;
}

export default function useSourceResultsTotal({
  listId,
  sourceId,
  enabled,
}: {
  listId: string;
  sourceId: string;
  enabled: boolean;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { listsKeys } = getQueryKeys(workspaceId);

  const { data: total, isLoading: isLoadingTotal } = useQuery({
    queryKey: listsKeys.sourceResultsTotal(listId, sourceId),
    queryFn: () => getSourceResultsTotal(workspaceId, listId, sourceId),
    enabled,
  });

  return { total, isLoadingTotal };
}
